import React, { useEffect, useState } from "react";
import "./GlobalStyle.css"; // You can style this as needed
import { getComments } from "../../api/ApiConfig";
import { BsX } from "react-icons/bs";

export default function SuggestionModal({
  postId,
  postType,
  data,
  onClose,
  onSelect,
}) {
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    const fetchSuggestions = async () => {
      try {
        const response = await getComments({ type: postType });
        setSuggestions(response.data);
      } catch (error) {
        console.error("Failed to fetch suggestions", error);
        setSuggestions([]);
      }
    };

    fetchSuggestions();
  }, [postType]);

  const handleSuggestionClick = (text) => {
    onSelect(text);
    onClose();  
  };

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal-container-wish">
        <div className="custom-modal-header">
          <p className="head">Comment</p>
          <button className="custom-modal-close" onClick={onClose}>
            <BsX size={20} />
          </button>
        </div>

        <div className="suggestion-container p-2">
          {suggestions.length > 0 ? (
            suggestions.map((txt, i) => (
              <button
                key={i}
                className="suggestion-btn"
                onClick={() => handleSuggestionClick(txt.comments)}
              >
                {txt.comments}
              </button>
            ))
          ) : (
            <p>No suggestions available</p>
          )}
        </div>
      </div>
    </div>
  );
}
